import { render, staticRenderFns } from "./AssignedTeamsToProject.vue?vue&type=template&id=5436fefa&scoped=true"
import script from "./AssignedTeamsToProject.vue?vue&type=script&lang=js"
export * from "./AssignedTeamsToProject.vue?vue&type=script&lang=js"
import style0 from "./AssignedTeamsToProject.vue?vue&type=style&index=0&id=5436fefa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436fefa",
  null
  
)

export default component.exports